import { ILocation, IUserSummary, IWorkProfile } from '../../types/global/helper';

export const types = {
    GET_SAVED_TALENTS: 'GET_SAVED_TALENTS',
    GET_SAVED_TALENT_SUCCESS: 'GET_SAVED_TALENT_SUCCESS',
    GET_SAVED_TALENT_FAIL: 'GET_SAVED_TALENT_FAIL',

    SAVE_TALENT: 'SAVE_TALENT',
    SAVE_TALENT_SUCCESS: 'SAVE_TALENT_SUCCESS',
    SAVE_TALENT_FAIL: 'SAVE_TALENT_FAIL',

    DELETE_SAVED_TALENT: 'DELETE_SAVED_TALENT',
    DELETE_SAVED_TALENT_SUCCESS: 'DELETE_SAVED_TALENT_SUCCESS',
    DELETE_SAVED_TALENT_FAIL: 'DELETE_SAVED_TALENT_FAIL',

    UPDATE_TALENT: 'UPDATE_TALENT',
    UPDATE_TALENT_SUCCESS: 'UPDATE_TALENT_SUCCESS',
    UPDATE_TALENT_FAIL: 'UPDATE_TALENT_FAIL',

    SEARCH_TALENT: 'SEARCH_TALENT',
    SEARCH_TALENT_SUCCESS: 'SEARCH_TALENT_SUCCESS',
    SEARCH_TALENT_FAIL: 'SEARCH_TALENT_FAIL',

    DELETE_TALENT: 'DELETE_TALENT',
    DELETE_TALENT_SUCCESS: 'DELETE_TALENT_SUCCESS',
    DELETE_TALENT_FAIL: 'DELETE_TALENT_FAIL',

    FIND_TALENT: 'FIND_TALENT',
    FIND_TALENT_SUCCESS: 'FIND_TALENT_SUCCESS',
    FIND_TALENT_FAIL: 'FIND_TALENT_FAIL',

    SET_TALENT_FILTERS: 'SET_TALENT_FILTERS',
};

export interface ITalentInitialState {
    talents: ITalentData[];
    loadingTalent: boolean;
    errMsg: string | null;
    talentSearchData: ITalentData[];
    deletingTalent: boolean;
    savingTalent: boolean;
    updatingTalent: boolean;
    searchingTalent: boolean;
    allTalents: IWorkProfile[];
    gettingTalents: boolean;
    filters?: ITalentFilters;
}

export interface ITalent {
    _id: string;
    firstName: string;
    lastName: string;
    userName: string;
    gender: string;
    __v: number;
    user_type: string[];
    location: ILocation;
    verified: boolean;
    interest: any[]; // Define more specific type if available
    updatedAt: string;
}

export type TalentSaveLocation = 'talentSearch' | 'userDashboard' | 'feed';

export interface ISaveTalent {
    talent: string;
    tags: string[];
    note: string;
    profile?: string;
    from?: TalentSaveLocation;
}

export interface IDeleteSaveTalent {
    saveId: string;
    payload: any;
}

export interface ITalentData {
    _id: string;
    talent: IUserSummary;
    created_by: string;
    created_at: string;
    tags: string[];
    note: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface IData {
    data: ITalentData[];
}

export interface IApiResponse {
    status: string;
    results: number;
    data: IData;
}
export interface ITalentSearchResponse {
    result: ITalentData[];
    total_result_count: number;
    matched_users: ITalent[];
}

export interface IGetSavedTalents {
    page?: number;
    limit?: number;
}

export interface ITalentFilters {
    searchTerm?: string;
    ageFrom?: number;
    ageTo?: number;
    gender?: string;
    rating?: number;
    languages?: string[];
    skills?: string[];
    page?: number;
    limit?: number;
    lat?: number;
    lng?: number;
    profile_type?: string;
    ethnicity?: string[];
    hair_color?: string;
    hair_type?: string;
    body_type?: string;
    language_spoken?: string[];
    /** Work work for labels only */
    location?: string;
}

export interface ITalentDiscoverResponse {
    status: string;
    results: number;
    total: number;
    totalPages: number;
    totalCount: number;
    pageSize: number;
    currentPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    nextPage: number | null;
    prevPage: number | null;
    data: IWorkProfile[];
}

export interface ITalentDiscoverState {
    loading: boolean;
    error: string | null;
    talents: IWorkProfile[];
    filters: ITalentFilters;
    pagination: {
        total: number;
        totalPages: number;
        currentPage: number;
        hasNextPage: boolean;
        hasPrevPage: boolean;
        nextPage: number | null;
        prevPage: number | null;
    };
}
